<template>
  <div class="app-guide" v-if="show">
    <div class="app-guide__content">
      <div class="app-guide__header">
        <h3 class="app-guide__title">欢迎使用{{ oemInfo.name }}企业营销平台</h3>
        <span class="app-guide__tip">&nbsp;&nbsp;&nbsp;网站搭建，离成功吸引目标还差2步哦！</span>
      </div>
      <div class="app-guide__body">
        <ul class="app-guide__step">
          <li class="app-guide__step-item">
            <img src="@/assets/guide-step-01.png" alt="步骤一">
            <span>上传产品服务</span>
          </li>
          <li class="app-guide__step-divide">
            <div class="app-guide__step-divide__dot">
              <i class="app-guide__step-divide__dot-item"></i>
              <i class="app-guide__step-divide__dot-item"></i>
              <i class="app-guide__step-divide__dot-item" style="width: 12px; height: 12px;"></i>
              <i class="app-guide__step-divide__dot-item"></i>
              <i class="app-guide__step-divide__dot-item"></i>
            </div>
          </li>
          <li class="app-guide__step-item">
            <img src="@/assets/guide-step-02.png" alt="步骤一">
            <span>云官网自定义装修</span>
          </li>
          <li class="app-guide__step-divide">
            <div class="app-guide__step-divide__dot">
              <i class="app-guide__step-divide__dot-item"></i>
              <i class="app-guide__step-divide__dot-item"></i>
              <i class="app-guide__step-divide__dot-item" style="width: 12px; height: 12px;"></i>
              <i class="app-guide__step-divide__dot-item"></i>
              <i class="app-guide__step-divide__dot-item"></i>
            </div>
          </li>
          <li class="app-guide__step-item">
            <img src="@/assets/guide-step-03.png" alt="步骤一">
            <span>智能投放</span>
          </li>
        </ul>
      </div>
      <div class="app-guide__footer">
        <span class="app-guide__tip">您可以自定云官网页面管理，设置页面样式及内容</span>
        <el-button type="primary" size="small" @click="handleOkBtnClick">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppGuide',

  data () {
    return {
      show: this.initGuide()
    }
  },

  computed: {
    oemInfo () {
      return this.$store.state.share.oemInfo
    }
  },

  methods: {
    initGuide () {
      const showGuide = localStorage.getItem('showGuide')
      return !showGuide
    },

    handleOkBtnClick () {
      this.show = false
      localStorage.setItem('showGuide', Date.now())
    }
  }
}
</script>

<style lang="scss">
.app-guide {
  position: fixed;
  z-index: 1000;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .5);

  &__content {
    width: 600px;
    height: 380px;
    margin: 184px auto 50px;
    background-color: #fff;
    overflow: hidden;
  }

  &__header {
    padding: 40px 40px 0;
    text-align: center;
  }

  &__body {
    padding: 68px 40px;
  }

  &__footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    box-shadow: 0 -2px 4px 0 #eee;
  }

  &__title {
    padding-bottom: 15px;
    margin-top: 0;
    margin-bottom: 15px;
    border-bottom: 1px solid $border-color;
    font-size: 18px;
  }

  &__tip {
    color: #999;
  }

  &__step {
    display: flex;
    justify-content: space-between;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  &__step-item {
    text-align: center;

    span {
      display: block;
      margin-top: 10px;
    }
  }

  &__step-divide {
    width: 100px;
    padding-top: 22px;

    &__dot {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &-item {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #ccc;
      }
    }
  }
}
</style>
